import { useAllCndnTypes } from "http-hooks/cndntypes/useCndnTypes";
import DeleteCndnTypes from "components/cndntypes/DeleteCndnTypes";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import Select from "components/ui/Select";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  StatusIcon,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const statusOptions = [
  { value: "", label: "All Status" },
  { value: "1", label: "Active" },
  { value: "0", label: "Inactive" },
];

const initialFilter = {
  name: "",
  ag_status: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "name", header: "Type Name" },
  {
    key: "ag_status",
    header: "Status",
    render: (item) => <StatusIcon value={item.ag_status} />,
  },
  { key: "actions", header: "Actions", isActions: true },
];

export default function CndnTypesMaster() {
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("cndntypes", id);

  const handleSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, name: searchTerm, page: 1 }));
  };

  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setFilter((prev) => ({
      ...prev,
      ag_status: selectedOption?.value || "",
      page: 1,
    }));
  };

  const clearFilters = () => {
    setSelectedStatus(null);
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allCndnTypes, page: currentPage, totalPages } = [],
  } = useAllCndnTypes(filter);

  return (
    <MasterPage
      title="Credit/Debit Note Types"
      headerActions={
        <AddButton onClick={() => openSetModal()}>
          Add Credit/Debit Note Type
        </AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleSearch}
              label="Type Name"
              placeholder="Search Type Name"
            />
          </FilterCell>
          <FilterCell>
            <Select
              options={statusOptions}
              value={selectedStatus}
              onChange={handleStatusChange}
              label="Status"
              placeholder="Select status"
              isClearable={true}
              isSearchable={false}
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allCndnTypes}
      isLoading={isLoading}
      rowKey="id"
      deleteComponent={DeleteCndnTypes}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction
            onClick={() => openSetModal(item.id)}
            title="Edit Credit/Debit Note Type"
            variant="secondary"
          />
          <DeleteAction
            onClick={() => setDeleteItemId(item.id)}
            title="Delete Credit/Debit Note Type"
          />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
